// Packages
const Big = require('big.js');

/*
 * IMPORTANT NOTES:
 * Research into Big.js: https://bobtail.atlassian.net/browse/SM-462
 *
 * The only times we don't deal in Big.js instances:
 *
 * FE Read/Write pair of cases for presentation:
 *
 * 1. Input from user
 * 2. Presenting value to user
 *
 * FE Read/Write pair of cases when communicating with the BE:
 *
 * 1. Reading a response from the BE
 * 2. Sending a request to the BE
 *
 * BE Read/Write pair of cases when communicating with the FE:
 *
 * 1. Reading a request
 * 2. Writing a response
 *
 * BE Read/Write pair of cases when communicating with database:
 *
 * 1. Reading a stored value
 * 2. Writing a stored value
 */

// Round towards nearest neighbor. If equidistant, round away from zero
// Applies to round, toExponential, toFixed, and
// (I.E. 0.5 rounds to 1 instead of 0)
Big.RM = 1

// Expecting big.js instances for each parameter
const calcApprovedAmount = (invoiceTotal, factorFee, reserveFee, deduction) => {
  return invoiceTotal
    .minus(factorFee)
    .minus(reserveFee)
    .minus(deduction)
}

// Expecting big.js instances for each parameter
const calcFactorFee = (invoiceTotal, factorRatePercent) => {
  const factorRateAsDecimal = Big(factorRatePercent).div(100)
  return invoiceTotal
    .times(factorRateAsDecimal)
    .round() // We're multipling by a fractional value, such as .0299, so we need to round
}

// Expecting big.js instances for each parameter
const calcInvoiceTotal = (primaryRate, detention, lumper, advance) => {
  return primaryRate
    .plus(detention)
    .plus(lumper)
    .minus(advance)
}

// Expecting big.js instances for each parameter
const calcPercentage = (value, totalValue) => {
  return value
    .div(totalValue)
    .times(100)
}

// Expecting big.js instances for each parameter
const calcReserveAfterDeduction = (balance, deduction) => {
  // Deduction is always a positive change to the client's balance
  return balance
    .plus(deduction)
}

// Expecting big.js instances for each parameter
const calcReserveFee = (invoiceTotal, reserveRatePercent) => {
  const reserveRateAsDecimal = Big(reserveRatePercent).div(100)
  return invoiceTotal
    .times(reserveRateAsDecimal)
    .round() // We're multipling by a fractional value, such as .0299, so we need to round
}

// For presentation of values to the user
// BE and FE used function
const convertBigToDollars = (big) => {
  return big
    .div(100)
    .toFixed(2)
}

// For conversion of Big to pennies for submitting values to BE
// BE and FE used function
const convertBigToPennies = (big) => {
  return big
    .toFixed(0)
}

// For conversion of user input to big instances for calculating on the FE for other values
// BE and FE used function (Watchdog reads from QB)
const convertDollarsToBig = (dollars) => {
  return Big(dollars)
    .times(100)
}

const convertToInteger = (value) => {
  if (!(value instanceof Big)) {
    throw TypeError(`value ${value} needs to be an instance of Big`);
  }
  return value.round().toNumber();
};

const convertPenniesToDollars = (value) => {
  return value/100;
}

module.exports = {
  calcApprovedAmount,
  calcFactorFee,
  calcInvoiceTotal,
  calcPercentage,
  calcReserveFee,
  calcReserveAfterDeduction,
  convertBigToDollars,
  convertBigToPennies,
  convertDollarsToBig,
  convertToInteger,
  convertPenniesToDollars,
}
